export default __webpack_public_path__ + "static/media/34.87207ec8.png";